(function () {
	'use strict';

	function initSection(section) {
		var track = section.querySelector('.m1o2-testimonials__track');
		var prev = section.querySelector('.m1o2-testimonials__nav--prev');
		var next = section.querySelector('.m1o2-testimonials__nav--next');
		var moreWrap = section.querySelector('.m1o2-testimonials__more');
		var moreButton = section.querySelector('.m1o2-testimonials__more-button');
		if (!track) return;

		function step() {
			var card = track.querySelector('.m1o2-testimonials__card');
			if (!card) return 0;
			var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
			return card.getBoundingClientRect().width + gap;
		}

		function updateNavState() {
			var maxScroll = track.scrollWidth - track.clientWidth;
			if (prev) prev.setAttribute('aria-disabled', track.scrollLeft <= 1 ? 'true' : 'false');
			if (next) next.setAttribute('aria-disabled', track.scrollLeft >= maxScroll - 1 ? 'true' : 'false');
		}

		function scrollByCards(direction) {
			track.scrollBy({ left: direction * step(), behavior: 'smooth' });
		}

		if (prev) {
			prev.addEventListener('click', function () { scrollByCards(-1); });
		}
		if (next) {
			next.addEventListener('click', function () { scrollByCards(1); });
		}
		track.addEventListener('scroll', updateNavState, { passive: true });
		window.addEventListener('resize', updateNavState);
		updateNavState();

		if (moreButton && moreWrap) {
			/* Mobile: reveal the next 3 hidden cards per click; retire the button when none are left. */
			var BATCH = 3;
			moreButton.addEventListener('click', function () {
				var hidden = track.querySelectorAll('.m1o2-testimonials__card--extra:not(.is-revealed)');
				var count = Math.min(BATCH, hidden.length);
				for (var i = 0; i < count; i += 1) {
					hidden[i].classList.add('is-revealed');
				}
				if (hidden.length <= BATCH) moreWrap.classList.add('is-hidden');
				if (count) hidden[0].focus({ preventScroll: false });
			});
		}
	}

	function initAll() {
		var sections = document.querySelectorAll('.m1o2-testimonials');
		for (var i = 0; i < sections.length; i += 1) {
			initSection(sections[i]);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		var section = event.target.querySelector('.m1o2-testimonials');
		if (section) initSection(section);
	});
})();
